import React from 'react';

import { PaginationWrapperLayoutProps } from '../types';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  SimpleBlock,
  useListContextRequired
} from 'ui-builder';

import styles from './PaginationWrapper.module.scss';

export default function PaginationWrapperWeb(props: PaginationWrapperLayoutProps) {

  const listContext = useListContextRequired();

  return (
    <>
      {props.children}
      {(listContext.hasMorePages!() || (listContext.isLoading && listContext.data.length > 0)) ? (
        <SimpleBlock className={styles.loadMoreButtonWrapper}>
          <Button
            color={ButtonColor.BLUE}
            variant={ButtonVariant.GHOST}
            text="Load more"
            size={ButtonSize.SMALL}
            isFullWidth
            onClick={() => {
              listContext.loadNextPage!();
            }}
            isDisabled={listContext.isLoading}
            isLoading={listContext.isLoading}
          />
        </SimpleBlock>
      ) : null}
    </>
  )
}
